import type { Options } from "../types";
import { download } from "../utils";

export const xlsx = (content: BlobPart, options: Options) => {
  download(content, options, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
};
